import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Box } from 'reactjs-admin-lte'
import { Pagination, Form, FormControl, FormGroup, ButtonToolbar, Button, InputGroup, Modal, ControlLabel } from 'react-bootstrap'
import Select from 'react-select';
import Moment, { defaultFormat } from 'moment';
import FontAwesome from 'react-fontawesome';
import ReportStore from '../../stores/ReportStore';
import PickupRecord from '../pu/PickupRecord'
import Chart from 'chart.js';
import { findDOMNode } from 'react-dom'

var NotificationSystem = require('react-notification-system');
const yTh = parseInt(Moment().format('YYYY')) + 543
const curMonth = parseInt(Moment().format('MM'))
class ReportMechanicWork extends Component {
  constructor(props) {
    super(props)

    const optionsYear = []

    for (var i = yTh; i >= 2557; i--) {
      optionsYear.push({
        value: i,
        label: i
      });
    }

    const optionsMonth = [
        { value: 0, label: 'ทั้งปี' },
        { value: 1, label: 'มกราคม' },
        { value: 2, label: 'กุมภาพันธ์' },
        { value: 3, label: 'มีนาคม' },
        { value: 4, label: 'เมษายน' },
        { value: 5, label: 'พฤษภาคม' },
        { value: 6, label: 'มิถุนายน' },
        { value: 7, label: 'กรกฎาคม' },
        { value: 8, label: 'สิงหาคม' },
        { value: 9, label: 'กันยายน' },
        { value: 10, label: 'ตุลาคม' },
        { value: 11, label: 'พฤศจิกายน' },
        { value: 12, label: 'ธันวาคม' }
    ];

    this.state = {
      loading:false,
      showTb:true,
      optionsYear:optionsYear,
      optionsMonth: optionsMonth,
      defaultYear:yTh,
      defaultMonth: curMonth,
      optionsEmp:[],
      defaultEmp:'',
      data:[],
      monthSelect:0,
      displayTb:'',
      displayBar:'none',
      btnBar:(<div><FontAwesome name='bar-chart'/>&nbsp;ดูกราฟแท่ง</div>),
      btnAction:'barchart',
    }
    this.barChart = null
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    this.loadStockRequesterList(this.state.defaultYear)
  }

  componentWillReceiveProps(newProps) {

  }

  setBarChart(dataSet=false) { 
    this.canvasBar = findDOMNode(this.canvasBarRef);
    this.ctxBar = this.canvasBar.getContext('2d');
    let canvasBar = this.canvasBar,ctxBar=this.ctxBar

    let {data} = this.state
    if (!dataSet)
      dataSet = data

    let labels = []
    let data_barchart = []
    let data_year = [0,0,0,0,0,0,0,0,0,0,0,0]
    let i = 0
    let January = 'มกราคม'
    let February = 'กุมภาพันธ์'
    let March = 'มีนาคม'
    let April = 'เมษายน'
    let May = 'พฤษภาคม'
    let June = 'มิถุนายน'
    let July = 'กรกฎาคม'
    let August = 'สิงหาคม'
    let September = 'กันยายน'
    let October = 'ตุลาคม'
    let November = 'พฤศจิกายน'
    let December = 'ธันวาคม'
    labels = [January,February,March,April,May,June,July,August,September,October,November,December]
    dataSet.forEach(function(item,index) {
      data_year[index] = parseFloat(data_year[index]) + parseFloat(item.cost_stock)
    })
    data_barchart = data_year
    if(this.barChart!=null){
      this.barChart.destroy();
    }
    this.barChart = new Chart(ctxBar, {
      type: 'bar',
      data: {
          labels: labels,
          datasets: [{
              label: 'ต้นทุนสินค้า',
              data: data_barchart,
              backgroundColor: 'green'
          }]
      },
      options: {
          scales: {
              yAxes: [{
                  ticks: {
                      beginAtZero:true
                  }
              }]
          }
      }
    });
  }

  getMonthText(month) {
    if (month==='1'||month===1)
      return 'มกราคม'
    else if (month==='2'||month===2)
      return 'กุมภาพันธ์'
    else if (month==='3'||month===3)
      return 'มีนาคม'
    else if (month==='4'||month===4)
      return 'เมษายน'
    else if (month==='5'||month===5)
      return 'พฤษภาคม'
    else if (month==='6'||month===6)
      return 'มิถุนายน'
    else if (month==='7'||month===7)
      return 'กรกฎาคม'
    else if (month==='8'||month===8)
      return 'สิงหาคม'
    else if (month==='9'||month===9)
      return 'กันยายน'
    else if (month==='10'||month===10)
      return 'ตุลาคม'
    else if (month==='11'||month===11)
      return 'พฤศจิกายน'
    else if (month==='12'||month===12)
      return 'ธันวาคม'
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getSummary(key) {
    let {data} = this.state
    let sum = 0
    data.forEach(function(item,index) {
      let value = (item[key]===''||item[key]===null||item[key]===undefined||isNaN(item[key])?0:item[key])
      sum += parseFloat(value)
    })
    return sum
  }

  newEmptyRow(number=1) {
    return new Array(number).fill(null).map((item,index)=>{
      return {month:index+1,name:'',cost_stock:''}
    })
  }

  loadStockRequesterList(year) {
    let {optionsEmp} = this.state
    ReportStore.loadStockRequesterList(year,(result)=> {
      result.data.forEach(function(item,index) {
        optionsEmp.push({
          label:item.name,
          value:item.name
        })
      })
      this.setState({optionsEmp:optionsEmp})
    })
  }

  loadEmpStock(year,name) {
    this.setState({loading:true})
    ReportStore.loadEmpStock(year,name,(result)=> {
      this.setState({data:result.data,loading:false})
      if (this.state.btnAction==='report')
        this.setBarChart(result.data)
    })
  }

  onYearChange(e) {
    let {defaultEmp} = this.state
    this.setState({defaultYear:e.value})
    this.loadEmpStock(e.value,defaultEmp)
  }

  onMonthChange(e) {
    
  }

  onRowSelect(year,month,name,e) {
    this.setState({showTb:false,monthSelect:month})
    this.refs.pickupRecord.loadPickupRecord(year,month,name)
  }

  onReportClose() {
    this.setState({showTb:true,monthSelect:0})
  }

  onBarChartClick(action,e) {
    let {displayTb,displayBar,btnBar,btnAction,defaultYear,defaultEmp} = this.state
    let new_action = ''
    if (action=='barchart') {
      new_action = 'report'
      this.setState({btnAction:new_action,displayTb:'none',displayBar:'',btnBar:(<div><FontAwesome name='file-text'/>&nbsp;ดูรายงาน</div>)})
      this.loadEmpStock(defaultYear,defaultEmp)
      this.setBarChart()  
    } else {
      new_action = 'barchart'
      this.setState({btnAction:new_action,displayTb:'',displayBar:'none',btnBar:(<div><FontAwesome name='bar-chart'/>&nbsp;ดูกราฟแท่ง</div>)})
      this.loadEmpStock(defaultYear,defaultEmp)
    }
  }

  renderRowData() {
    let {data} = this.state
    if (data.length===0) {
      return(<tr><td colSpan={6}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        data.map((item,index)=> {
          return(
            <tr key={index}>
              <td className='text-center'>{index+1}</td>
              <td className='text-center'></td>
              <td>{item.name}</td>
              <td className='text-center'></td>
              <td className='text-center'></td>
              <td className='text-center'></td>
            </tr>
          )
        })
      )
    }
  }

  renderTable() {
    return(
      <div className='table-responsive'>
        <table className='table table-responsive table-hover table-bordered-solid table-tool' style={{marginBottom:'0'}}>
            <thead>
              <tr>          
                <th className='text-center' style={{ width: '5%' }}>ลำดับ</th>
                <th className='text-center' style={{ width: '10%' }}>เดือน</th>
                <th className='text-center' style={{ width: '35%' }}>จำนวนรายการ</th>
                <th className='text-center' style={{ width: '16.66%' }}>รื้อ</th>
                <th className='text-center' style={{ width: '16.66%' }}>เคาะ</th>
                <th className='text-center' style={{ width: '16.66%' }}>โป๊ว</th>
              </tr>  
            </thead>
            <tbody>
              {this.renderRowData()}
            </tbody>
        </table>
      </div>
    )  
  }

  renderBarChat() {
    return(
      <div>
        <canvas 
          ref={(canvasBar) => { this.canvasBarRef = canvasBar; }}>
        </canvas>
      </div>
    )
  }

  render() {
    let {loading,showTb} = this.state
    return(
      <div>
        <div style={{display:(showTb?'':'none')}}>
          <Box loading={loading}>           
            <Box.Header border={true}>          
              {this.props.renderMenu()}
            </Box.Header>            
            <Box.Body>
              <Form inline>
                <FormGroup>
                    <Select
                        clearable={false}
                        name="form-field-name"
                        value={ this.state.defaultYear }
                        options={this.state.optionsYear}
                        style={{ width: '80px' }}
                        onChange={ this.onYearChange.bind(this) }
                    />
                </FormGroup>
                {' '}
                <FormGroup>
                    <Select
                        clearable={false}
                        name="form-field-name"
                        value={ this.state.defaultMonth }
                        options={this.state.optionsMonth}
                        style={{ width: "110px" }}
                        onChange={ this.onMonthChange.bind(this) }
                    />
                </FormGroup>
                {' '}
                {/* <FormGroup>
                    <Button
                    className='btn-primary'
                    onClick={this.onBarChartClick.bind(this,this.state.btnAction)}
                    >
                        {this.state.btnBar}
                    </Button>
                </FormGroup> */}
              </Form>
              <br/>
              <div style={{display:this.state.displayTb}}>
                {this.renderTable()}
              </div>
              <div style={{display:this.state.displayBar}}>
                {this.renderBarChat()}
              </div>  
            </Box.Body>
          </Box>     
        </div>  
      </div>
    )
  }
}

ReportMechanicWork.defaultProps = {
  
}

export default ReportMechanicWork;  


// WEBPACK FOOTER //
// ./src/view/report/ReportMechanicWork.js